export default __webpack_public_path__ + "static/assets/5e2cf7b1d36c26f8b8c3a31dd223c0e8.gif";